import React from 'react';

const SubmissionSuccess = () => {
  return (
    <div>
      <h3>Form Submitted Successfully!</h3>
      <p>Thank you for your submission.</p>
      <p>You will soon receive an email notification. If not, please check your spam folder.</p>
    </div>
  );
};

export default SubmissionSuccess;